/**
 * Case create APIs require `patient_id` = guardian (account holder) user id.
 * Dependent profiles include `guardian_id`; primary accounts use their own `id`.
 */
export function resolveGuardianPatientIdForCase(
  profile: { id?: number; guardian_id?: number | null } | null | undefined,
  formSelectedPatientUserId: string | number | undefined,
): number | null {
  if (profile != null && typeof profile.id === 'number' && !Number.isNaN(profile.id)) {
    const g = profile.guardian_id;
    if (g != null && g !== undefined && !Number.isNaN(Number(g))) {
      return Number(g);
    }
    return Number(profile.id);
  }
  if (formSelectedPatientUserId !== undefined && formSelectedPatientUserId !== null && formSelectedPatientUserId !== '') {
    const n = Number(formSelectedPatientUserId);
    if (Number.isFinite(n) && n > 0) {
      return n;
    }
  }
  return null;
}
